import { render, staticRenderFns } from "./ListItemCorporate.vue?vue&type=template&id=bc2e2d72&"
import script from "./ListItemCorporate.vue?vue&type=script&lang=js&"
export * from "./ListItemCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports